module.exports = __webpack_public_path__ + "img/c02_buildingessenceofthecobra_Normal_ua.1990d0d4.webp";